function addMinutes(date: Date, minutes: number): Date {
  return new Date(date.getTime() + minutes * 60 * 1000);
}

export function ensureEndNotBeforeStart(
  start: Date | null,
  end: Date | null,
  minutes: number = 15,
): Date | null {
  if (!start || !end) return end;
  if (end.getTime() <= start.getTime()) return addMinutes(start, minutes);
  return end;
}

export function parseDateTimeOrNull(
  value: string | null | undefined,
): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function calendarValueToDateOrNull(value: unknown): Date | null {
  return value instanceof Date ? value : null;
}


